interface SequenceProgressProps {
  length: number;
  isShowing: boolean;
  showingStep: number;
  userSequence: number[];
  isInputEnabled: boolean;
}

export default function SequenceProgress({
  length,
  isShowing,
  showingStep,
  userSequence,
  isInputEnabled,
}: SequenceProgressProps) {
  return (
    <div className="flex items-center justify-end gap-1.5">
      <span className="text-[11px] font-semibold text-foreground-400 mr-1 whitespace-nowrap">
        순서
      </span>
      {Array.from({ length }, (_, i) => {
        const state = isShowing
          ? i < showingStep
            ? 'done'
            : i === showingStep
              ? 'current'
              : 'remaining'
          : i < userSequence.length
            ? 'done'
            : i === userSequence.length && isInputEnabled
              ? 'current'
              : 'remaining';

        return (
          <div
            key={i}
            className={`
              w-6 h-6 rounded-md flex items-center justify-center
              text-xs font-bold transition-all duration-300
              ${state === 'done'
                ? 'bg-primary-500 text-white'
                : state === 'current'
                  ? 'bg-primary-100 text-primary-700 border border-primary-300'
                  : 'text-foreground-300'}
            `}
          >
            {i + 1}
          </div>
        );
      })}
    </div>
  );
}